<script setup lang="ts">
import { Coordinates } from "@soft-db/monitoring-api-client";
import { PropType } from "vue";

const props = defineProps({
	coordinates: { type: Object as PropType<Coordinates>, required: true },
});

const { t } = useI18n();

const href = computed(
	() =>
		`https://www.google.com/maps/search/?api=1&query=${props.coordinates.latitude},${props.coordinates.longitude}`
);
</script>
<template>
	<div class="flex items-center gap-2 py-1">
		<h5>{{ t("common.location") }}:</h5>
		<a :href="href" class="text-primary text-xs underline" target="_blank">
			{{ coordinates.latitude }}, {{ coordinates.longitude }}
		</a>
	</div>
</template>
